import { BlocksIconLayoutModule } from 'blocks-nextjs/blocks-web-components/components/icon/icons/layout-module';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconLayoutModule = createComponent({ react: React, tagName: 'cat-icon-layout-module', elementClass: BlocksIconLayoutModule });
